import {OngoingDraftResponse} from './OngoingDraftResponse.js'

export class DraftResponsesFactory {
  /**
   * @method
   * @param {Object} draft
   * @return {OngoingDraftResponse}
   */
  static ongoingDraftResponse = ({status, draftEntity}) => new OngoingDraftResponse({status, draftEntity})
}
